import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { AgFormat } from "../../common/utils/agGridFormat";
import {
  ICprGbisSearchCriteria,
  IHeaders,
  INbiKpi,
  INbiResponse,
} from "../../common/utils/types";

export class NbiTopDealsOutput {
  public constructor(public data: any[]) {}
}

export function mapData(data: IGenericAggregateResponse): NbiTopDealsOutput {
  if (data.aggregates && data.aggregates.length === 0) {
    return new NbiTopDealsOutput([]);
  }
  const dimensions = new NbiDimensions();
  const topValues: any[] = [];
  for (const item of data.aggregates ? data.aggregates : []) {
    if (item.dimensionAttributeValues !== undefined) {
      topValues.push({
        BEResCtry: item.dimensionAttributeValues[dimensions.BE_RES_CTRY_NAME],
        BL: item.dimensionAttributeValues[dimensions.FPV_BL],
        Date: AgFormat.AgGridFormatDate(
          item.dimensionAttributeValues[dimensions.GBIS_CREDIT_DATE]
        ),
        Nbi: item.indicatorKpiValues.nbi_rol_yr,
        OEResCtry: item.dimensionAttributeValues[dimensions.OE_RES_CTRY_NAME],
        ProductLevel3: item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL3],
        SBL: item.dimensionAttributeValues[dimensions.FPV_SBL],
        SalesName: item.dimensionAttributeValues[dimensions.SALESBEN_SALES],
        TeamName: item.dimensionAttributeValues[dimensions.SALESBEN_TEAM],
      });
    }
  }

  return new NbiTopDealsOutput(topValues);
}
